import React from "react"
import ReactDOM from "react-dom"
import { Lock } from "lucide-react"

const FF   = "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
const MONO = "'IBM Plex Mono', monospace"

const T = {
  border:       "0.5px solid #e5e7eb",
  radius:       8,
  radiusCard:   10,
  bg:           "#fff",
  bgMuted:      "#fafaf9",
  text:         "#111827",
  textMuted:    "#374151",
  textTertiary: "#6b7280",
  shadow:       "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)",
}

const NoPermissionOverlay = ({ isOpen, onClose }) => {
  if (!isOpen) return null

  return ReactDOM.createPortal(
    <>
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.32)",
          backdropFilter: "blur(2px)",
          zIndex: 60,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 16,
          fontFamily: FF,
        }}
      >
        <div
          style={{
            background: T.bg,
            border: T.border,
            borderRadius: T.radiusCard + 2,
            boxShadow: "0 8px 32px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.06)",
            width: "100%",
            maxWidth: 360,
            overflow: "hidden",
          }}
        >
          {/* Header strip */}
          <div
            style={{
              padding: "13px 20px",
              background: T.bgMuted,
              borderBottom: T.border,
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <div
              style={{
                width: 7,
                height: 7,
                borderRadius: "50%",
                background: "#ef4444",
                flexShrink: 0,
              }}
            />
            <span
              style={{
                fontSize: 11,
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                color: T.textTertiary,
                fontFamily: MONO,
              }}
            >
              Access restricted
            </span>
          </div>

          {/* Body */}
          <div style={{ padding: "28px 24px 24px" }}>
            {/* Icon */}
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: T.radiusCard,
                border: T.border,
                background: T.bgMuted,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 16,
                boxShadow: T.shadow,
              }}
            >
              <Lock size={18} color={T.textTertiary} strokeWidth={1.5} />
            </div>

            {/* Title */}
            <p
              style={{
                margin: "0 0 6px",
                fontSize: 15,
                fontWeight: 700,
                color: T.text,
                letterSpacing: "-0.02em",
                fontFamily: FF,
              }}
            >
              Permission required
            </p>

            {/* Description */}
            <p
              style={{
                margin: "0 0 24px",
                fontSize: 13,
                fontWeight: 500,
                color: T.textTertiary,
                lineHeight: 1.6,
                fontFamily: FF,
              }}
            >
              You don't have permission to view this page. Contact one of the
              admins in your organisation to request access.
            </p>

            {/* Dismiss button */}
            <button
              onClick={onClose}
              style={{
                width: "100%",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                height: 36,
                padding: "0 18px",
                borderRadius: T.radius,
                border: T.border,
                background: T.bg,
                color: T.text,
                fontSize: 13,
                fontWeight: 600,
                fontFamily: FF,
                cursor: "pointer",
                transition: "background 0.12s",
                outline: "none",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = T.bgMuted }}
              onMouseLeave={(e) => { e.currentTarget.style.background = T.bg }}
            >
              Dismiss
            </button>
          </div>
        </div>
      </div>
    </>,
    document.body,
  )
}

export default NoPermissionOverlay